module.exports = __webpack_public_path__ + "static/media/top-clouds-1.18446e84.png";